
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
  closeModal(): void {
    this.$emit('close-modal');
  }
}
